import { getOneWebWKOs } from '@/services/oneweb'
import { EnvironmentConfig, EventDetail } from '@/config/interface'
import { WellKnownObjects } from '@owc/connection-wko-manager'
import { StreamSSE } from '@/store/interfaces'
import { MediaQuery } from '@workbench/core'
import EventSource from 'eventsource'
import { NotificationsState } from '@/store/notifications/interfaces'
import config from '@/config/env.config'
import markets, { Region } from '@/config/markets'
import { getTrackingDispatchers, TrackingEvent } from '@owc/connection-aem-tracking'
import { AnyAction } from 'redux'
import { analyticsEvt } from '@/config/analytics.config'

export const MOBILE_BREAKPOINTS = ['mq1', 'mq2']
export let neverOpenedFlyout = true
export const streamsSSE: StreamSSE[] = []
export const initialNotificationsState: NotificationsState = {
  unread: 0,
  total: 0,
  list: [],
  error: null,
  isFetching: false,
  hasLoaded: false,
  allNotificationsLoaded: false,
  attrs: {
    warningScheduleRemovalDismissed: true,
  },
}

export const setOpenedFlyout = (): boolean => (neverOpenedFlyout = false)

export type OwcTrackingDispatchers = {
  pushTrackingEvent: (trackingEvent: TrackingEvent) => AnyAction
}

export const manageAnalyticsOpen = (): void => {
  if (neverOpenedFlyout) {
    const event: EventDetail = {
      category: 'impression',
      action: 'header.notifications_&_messages',
      label: 'open',
    }
    pushAnalyticsEvent(event)
    setOpenedFlyout()
  }
}

export const getRegionFromCountry = (country: string): Region => {
  // get region
  return markets.countryToRegion[country] || markets.countryToRegion.default
}

export const getEnvironmentConfig = async (state?: WellKnownObjects): Promise<EnvironmentConfig> => {
  const stage = (state ?? (await getOneWebWKOs())).Environment?.stage?.toLowerCase() ?? 'dev'
  return config[stage === 'preprod' ? 'pprod' : stage]
}

export const pushAnalyticsEvent = async (evt: EventDetail): Promise<void> => {
  const event: TrackingEvent = analyticsEvt(evt)
  const analytics = await getTrackingDispatchers()
  analytics.pushTrackingEvent(event)
}

export const isMobileScreen = (breakpoint: MediaQuery): boolean => MOBILE_BREAKPOINTS.includes(breakpoint)

//Loop through all streams that have been previously closed and reconnect to every stream
export const openStreams = (): void => streamsSSE.forEach((stream) => stream.funcs())

//Loop through all streams opened, and close their eventsources
export const closeStreams = (): void => streamsSSE.forEach((stream) => stream.sse.close())

export const manageStream = (name: string, sse: EventSource, funcs: CallableFunction): void => {
  //Check whether a server sent event is already saved in streamsSSE
  //if not, it pushes a new object with name, event source, and function to be called to connect to the stream
  //if a stream with same name is already in streamsSSE it finds the array entrance with the same name
  //and replaces the server sent event with the new one
  const hasSSE: boolean = streamsSSE.some((el) => el.name === name)
  hasSSE
    ? streamsSSE.forEach((el) => (el.sse = el.name === name ? sse : el.sse))
    : streamsSSE.push({ name, sse, funcs })
}
